/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Tailor_ResumeInputs */

const en_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tailor Resume`)
};

const de_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf anpassen`)
};

const fr_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapter le CV`)
};

const es_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptar currículum`)
};

const it_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizza curriculum`)
};

const nl_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV op maat maken`)
};

const pl_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostosuj CV`)
};

const fi_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Räätälöi ansioluettelo`)
};

const da_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skræddersy CV`)
};

const sv_jobs_tailor_resume = /** @type {(inputs: Jobs_Tailor_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skräddarsy CV`)
};

/**
* | output |
* | --- |
* | "Tailor Resume" |
*
* @param {Jobs_Tailor_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_tailor_resume = /** @type {((inputs?: Jobs_Tailor_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Tailor_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_tailor_resume(inputs)
	if (locale === "fr") return fr_jobs_tailor_resume(inputs)
	if (locale === "es") return es_jobs_tailor_resume(inputs)
	if (locale === "it") return it_jobs_tailor_resume(inputs)
	if (locale === "nl") return nl_jobs_tailor_resume(inputs)
	if (locale === "pl") return pl_jobs_tailor_resume(inputs)
	if (locale === "fi") return fi_jobs_tailor_resume(inputs)
	if (locale === "da") return da_jobs_tailor_resume(inputs)
	if (locale === "sv") return sv_jobs_tailor_resume(inputs)
	return en_jobs_tailor_resume(inputs)
});